module.exports = __webpack_public_path__ + "img/graph-up.a18db12c.svg";